import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-asm",
  "use": "icon-asm-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-asm\"><path fill=\"#333333\" d=\"M840.704 28.672V153.6H28.672V28.672m154.624 280.576h812.032v124.928H183.296V309.248zM28.672 587.776h812.032v125.952H28.672V587.776z m154.624 281.6h812.032v125.952H183.296V869.376z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol